<template>
  <div v-if="appData">
    <div v-if="isSucceed" class="succeed-box intro-x">
      <div class="succeed-png">
        <img src="@/assets/images/succeeds.png" alt="" />
      </div>

      <div class="contentText">
        <div style="font-size: 16px; color: #333333">支付成功</div>
        <div style="font-size: 20px; color: #1890ff">
          ¥ {{ appData.data.price | formatMoney }}
          
        </div>
        <div style="font-size: 12px; color: #999999">
          支付成功，点击下面按钮继续进行应用创建的步骤吧！
        </div>
      </div>
    </div>
    <div v-else class="error-box intro-x">
      <div class="succeed-png">
        <img src="@/assets/images/errors.png" alt="" />
      </div>
      <div class="contentText">
        <div style="font-size: 16px; color: #333333">支付失败</div>
        <div style="font-size: 20px; color: #ff4242">
          ¥ {{ appData.data.price | formatMoney }}
        </div>
        <div style="font-size: 12px; color: #999999">
          失败原因：{{ appData.msg || '未支付' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
 
  props: ["isSucceed", "appData"],
  data() {
    return {};
  },

  mounted: function(){
 
  },
};
</script>

<style lang="scss" scoped>
.succeed-png,
.error-png {
  width: 125px;
  height: 125px;
  background: #f3f3fa;
  border-radius: 50%;
  overflow: hidden;
  margin: 60px auto 5px;
  img {
    width: 100%;
    height: 100%;
  }
}
.contentText {
  text-align: center;
  line-height: 28px;
}
</style>